import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';
import { getDateTime } from '@shared/utils';


@Pipe({
    name: 'age',
    pure: false,
    standalone: true
})
export class AgePipe implements PipeTransform {
    private readonly translateService = inject(TranslateService);

    /**
     * O valor chega já na hora de parede da conta — a conversão de UTC acontece na
     * fronteira com o backend. Este pipe só calcula.
     */
    transform(value: string | Date): string {
        const date = getDateTime(value);

        if (!date?.isValid) {
            return this.translateService.instant('COMPONENTS.RELATIVE_DATE.INVALID_DATE');
        }
        const now = DateTime.now();

        const years = Math.floor(now.diff(date,'years').years);
        if (years >= 1) return this.translateService.instant(years > 1 ? 'COMPONENTS.RELATIVE_DATE.UNITS.YEARS' : 'COMPONENTS.RELATIVE_DATE.UNITS.YEAR', { number: years });

        const months = Math.floor(now.diff(date, 'months').months);
        if (months >= 1) return this.translateService.instant(months > 1 ? 'COMPONENTS.RELATIVE_DATE.UNITS.MONTHS' : 'COMPONENTS.RELATIVE_DATE.UNITS.MONTH', { number: months });

        const days =  Math.floor(now.diff(date, 'days').days);
        return this.translateService.instant(days > 1 ? 'COMPONENTS.RELATIVE_DATE.UNITS.DAYS' : 'COMPONENTS.RELATIVE_DATE.UNITS.DAY', { number: days });
    }
}